import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { UiObject } from "@models/configurators/ui-object";
import { ISvgViewer } from "@models/entity-models";
import { eRuleType } from "@models/enums";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { RuleContainer } from "@models/configurators/rule-container";
import { IDummyNode } from "@models/configurators/kb-object";

@Kbo(CToken.SvgViewer)
export class SvgViewer extends UiObject implements ISvgViewer {

    constructor(kom: KbObjectManager) {
        super(kom, { ruleType: eRuleType.svgViewer });
        this.$rulesNode = { id: this.id + "_rules", $type: "RulesNode", allowedChildren: () => [CToken.Rule], getParent: () => this }
    }

    public $rulesNode: IDummyNode;

    public autoValidation: boolean;

    public defs: string;

    public disablePan: boolean;

    public disableZoom: boolean;

    public maxZoom: number;

    public minZoom: number;

    public panX: number;

    public panY: number;

    public svgHeight: string;

    public svgWidth: string;

    public zoomLevel: number;

    public value: string;

    public svgStyle: string;

    public ruleContainers: RuleContainer[] = [];
}
